const PerTrxAmountCalcMethods: any = {
  FLAT_AMOUNT: 'Flat Amount',
  // MODULO: 'Modulo',
  PERCENTAGE: 'Percentage',
};

export default PerTrxAmountCalcMethods;
